import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getCompanies, getContactTypes, getUserApi } from 'api';
import { useNotificationProvider } from 'hooks';
import { selectUserInfo } from 'redux/userInfo/userInfoSlice';
import { initProfileUser } from '../data/profileData';
import getLanguagesApi from 'api/languages/getLanguagesApi';
import getRoleGroupApi from 'api/users/getRoleGroupApi';

/**
 * @component useProfile
 * @returns {Object}
 */
function useProfile() {
	const { notifyError } = useNotificationProvider(); // notifySucces
	const { userInfo } = useSelector(selectUserInfo);

	const [loading, setLoading] = useState(false);
	const [openPwd, setOpenPwd] = useState(false);
	const [canEdit, setCanEdit] = useState(false);
	const [user, setUser] = useState(initProfileUser);
	const [languages, setLanguages] = useState([]);
	const [contactTypes, setContactTypes] = useState([]);
	const [roleGroups, setRoleGroups] = useState([]);
	const [companies, setCompanies] = useState([]);
	const [accessibleData, setAccessibleData] = useState([
		{ RowNumber: '0', Id: '0', Name: 'All Companies' },
	]);

	const onOpenPwd = () => {
		setOpenPwd(!openPwd);
	};

	const onCanEdit = () => {
		setCanEdit(!canEdit);
	};

	const onInitUser = async () => {
		const fetchedUser = await getUserApi(userInfo.userId);
		const fetchedLanguages = await getLanguagesApi();
		const fetchedContactTypes = await getContactTypes();
		const { roleGroups } = await getRoleGroupApi();
		const fetchedCompanies = await getCompanies();

		/** Todo: clean up the code */
		if (fetchedUser.addressIds.length === 0) {
			fetchedUser.addresses = [];
		}

		setUser(fetchedUser);
		setLanguages(fetchedLanguages);
		setContactTypes(fetchedContactTypes);
		setRoleGroups(roleGroups);
		setCompanies(fetchedCompanies);
		setAccessibleData((prev) => [
			...prev,
			...fetchedCompanies.filter((company) => company.Id === fetchedUser.masterCustId),
		]);
	};

	const onSetUser = async () => {
		try {
			setLoading(true);
			await onInitUser();
		} catch (error) {
			notifyError(error.message);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (userInfo.userId !== '') {
			(async () => {
				try {
					setLoading(true);
					await onInitUser();
				} catch (error) {
					notifyError(error.message);
				} finally {
					setLoading(false);
				}
			})();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [notifyError, userInfo]);

	const state = {
		canEdit,
		loading,
		openPwd,
		user,
		userInfo,
		languages,
		contactTypes,
		roleGroups,
		companies,
		accessibleData,
	};

	const handler = { onOpenPwd, onCanEdit, onSetUser };

	return { state, handler };
}

export default useProfile;
